import { render } from "./Juvenil.vue?vue&type=template&id=c891191a"
import script from "./Juvenil.vue?vue&type=script&lang=js"
export * from "./Juvenil.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__